// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-section p,
.accordion {
    width: 75%;
}

.accordion .accordion-button:focus,
.accordion .accordion-button:not(.collapsed) {
    box-shadow: none;
}

.accordion .accordion-button:not(.collapsed) {
    background-color: #dc3545;
    color: #ffffff;
}

.accordion .accordion-button:not(.collapsed)::after {
    filter: invert();
}

@media only screen and (max-width: 992px) {
    .faq-section p,
    .accordion {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/FaqAccordion/FaqAccordion.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;;QAEI,WAAW;IACf;AACJ","sourcesContent":[".faq-section p,\n.accordion {\n    width: 75%;\n}\n\n.accordion .accordion-button:focus,\n.accordion .accordion-button:not(.collapsed) {\n    box-shadow: none;\n}\n\n.accordion .accordion-button:not(.collapsed) {\n    background-color: #dc3545;\n    color: #ffffff;\n}\n\n.accordion .accordion-button:not(.collapsed)::after {\n    filter: invert();\n}\n\n@media only screen and (max-width: 992px) {\n    .faq-section p,\n    .accordion {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
